import { BasketItem, BasketModel } from '../../models';
/**
 * Service responsible for storing the basket.
 * It's responsible for the type of storage and the format in that storage.
 */
export class BasketStorage {
    constructor(window, basketSettings, siteContextResolverService) {
        this.window = window;
        this.basketSettings = basketSettings;
        this.siteContextResolverService = siteContextResolverService;
        this.context = this.siteContextResolverService.getMappedContext();
        this.transformToBasketItem = (response) => {
            const fundData = new BasketItem(response.id, response.ticker === '-' ? '' : response.ticker, response.name, response.url, response.active, response.unlinked, response.shareClass, response.sfdr, response.isAlternative, response.nonSustainableId, response.inactivated, response.assetClass, response.alternativeCounter, response.alternativeOrder);
            fundData.timestamp = new Date();
            return fundData;
        };
        this.setBasketSettingsParams();
    }
    setBasketSettingsParams() {
        const { basketKey, campaignKey } = this.basketSettings.getSetting();
        const invTypeWithLang = this.setInvestorTypeAndLanguage();
        if (!basketKey.includes(this.context) || !basketKey.includes(invTypeWithLang)) {
            this.basketSettings.basketKey = `${this.context}${basketKey}${invTypeWithLang}`;
            this.basketSettings.storage = this.get();
        }
        if (!campaignKey.includes(this.context)) {
            this.basketSettings.campaignKey = `${this.context}${this.basketSettings.getSetting().campaignKey}`;
        }
    }
    transformToBasket(basketJson) {
        const funds = basketJson === null || basketJson === void 0 ? void 0 : basketJson.funds;
        const basket = new BasketModel();
        if (Array.isArray(funds)) {
            basket.funds = funds.map((fund) => this.transformToBasketItem(fund));
            return basket;
        }
        return basket;
    }
    setInvestorTypeAndLanguage() {
        const separator = '-';
        const paths = this.window.location.pathname.split('/');
        if (this.context && this.context !== 'us' && !!paths[2]) {
            const separatorWithInvType = `${separator}${paths[2]}`;
            if (this.context.includes('ch') && paths[3]) {
                return `${separatorWithInvType}${separator}${paths[3]}`; // paths[3] = language
            }
            return separatorWithInvType;
        }
        return '';
    }
    get getBasketKey() {
        return this.basketSettings.getSetting().basketKey;
    }
    set setBasketKey(basketKey) {
        this.basketSettings.basketKey = basketKey;
    }
    get() {
        return this.basketSettings.getSetting().storage;
    }
    readBasket() {
        const current = this.basketSettings
            .getSetting()
            .storage.getItem(this.basketSettings.getSetting().basketKey);
        return current !== null ? this.parseBasketJson(current) : new BasketModel();
    }
    readAlternativeStates() {
        return JSON.parse(this.basketSettings
            .getSetting()
            .storage.getItem(`${this.basketSettings.getSetting().basketKey}-alternative-states`));
    }
    parseBasketJson(storedBasket) {
        try {
            return this.transformToBasket(JSON.parse(storedBasket));
        }
        catch (errorMessage) {
            console.error(`Error happened while reading the basket from the storage: ${errorMessage}`);
            return new BasketModel();
        }
    }
    storeBasket(basket) {
        this.basketSettings
            .getSetting()
            .storage.setItem(this.basketSettings.getSetting().basketKey, JSON.stringify(basket));
    }
    storeAlternativeToggleState(toggleState) {
        const alternativeStates = this.readAlternativeStates();
        this.basketSettings
            .getSetting()
            .storage.setItem(`${this.basketSettings.getSetting().basketKey}-alternative-states`, JSON.stringify(Object.assign(Object.assign({}, alternativeStates), { toggleState })));
    }
    readCampaignId() {
        return this.basketSettings
            .getSetting()
            .storage.getItem(this.basketSettings.getSetting().campaignKey);
    }
    storeCampaignId(id) {
        this.basketSettings
            .getSetting()
            .storage.setItem(this.basketSettings.getSetting().campaignKey, id);
    }
}
